export default {
  boothConsultation: 'Booth consultation',
  exhibitionTicketConsultation: 'Exhibition ticket consultation',
  boothSale: 'Booth Sales',
  telephone: 'Telephone',
  mobilePhone: 'Mobile phone',
  wechat: 'Wechat',
  onlineContact: 'Online contact',
  workTime: 'Work time'
}
